import React from 'react'
import type { Icon } from 'shared/utils'
import { COLOR } from 'app-v2/design-tokens'

export const CardCBIcon = ({
    color = COLOR.PRIMARY,
    size = 340,
    ...otherProps
}: Icon) => (
    <svg
        width={size}
        height={(size / 340) * 255}
        viewBox="0 0 340 255"
        {...otherProps}>
        <rect width="340" height="255" rx="30" fill={color} />
        <path
            d="M290.958 123.906C294.845 124 298.712 123.322 302.334 121.912C305.956 120.502 309.26 118.389 312.056 115.695C314.851 113.001 317.081 109.78 318.617 106.219C320.152 102.659 320.962 98.8291 321 94.9535C320.962 91.0778 320.152 87.2483 318.617 83.6875C317.081 80.1268 314.851 76.9058 312.056 74.2118C309.26 71.5178 305.956 69.4046 302.334 67.995C298.712 66.5854 294.845 65.9074 290.958 66.0006H181.588V123.965H290.958V123.906Z"
            fill="#F5F5F5"
        />
        <path
            d="M290.958 131.688H181.588V189.594H290.958C294.845 189.687 298.712 189.009 302.334 187.599C305.956 186.19 309.26 184.077 312.056 181.383C314.851 178.689 317.081 175.468 318.617 171.907C320.152 168.346 320.962 164.517 321 160.641C320.962 156.765 320.152 152.936 318.617 149.375C317.081 145.814 314.851 142.593 312.056 139.899C309.26 137.205 305.956 135.092 302.334 133.682C298.712 132.273 294.845 131.595 290.958 131.688Z"
            fill="#F5F5F5"
        />
        <path
            d="M124.615 66.4065H73.6851C59.1817 66.4065 45.2723 72.1499 35.0169 82.3731C24.7614 92.5963 19 106.462 19 120.92L19 135.484C19 149.942 24.7614 163.807 35.0169 174.031C45.2723 184.254 59.1817 189.997 73.6851 189.997H124.615C139.118 189.997 153.028 184.254 163.283 174.031C173.539 163.807 179.3 149.942 179.3 135.484V131.682H99.15V123.961H179.476V120.92C179.476 113.746 178.056 106.643 175.297 100.018C172.537 93.3925 168.494 87.3752 163.397 82.3109C158.3 77.2466 152.251 73.2348 145.596 70.5056C138.941 67.7764 131.811 66.3834 124.615 66.4065Z"
            fill="#F5F5F5"
        />
    </svg>
)
